import { Navigate, Outlet } from 'react-router-dom';

import { ROUTES } from 'constants/routePaths';
import { useAuth } from 'hooks/useAuth';

/** Blocks authenticated users from public-only pages (e.g. login). */
export function PublicRoute() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}

export default PublicRoute;
